import React from "react";
import PropTypes from "prop-types";
import {
  //   Heading,
  //   Divider,
  TemplatePreviewHeader,
  TemplatePreviewModal,
  TemplatePreviewImageBox,
  TemplatePreviewFooter,
  UserInitialsMain,
} from "./styles";
import { LikeIcon, ManagerCloseIcon, SocialFeedCommentIcon } from "../../utils/icons";
import { ImageUrl } from "../../utils/constants";
import { getInitials, getReceiverNameColor } from "../../utils/methods";
import { Divider, ManagerIconContainer, StyledModal } from "../Manager/styles";
// import LazyImage from "../common/LazyImage/LazyImage";

const TemplatePreviewPopup = ({
  show,
  onClose,
  template,
  modalData,
  loggedInUser,
  type_id,
}) => {
  const containsDefaultPng = (str) => !str || str?.includes("default.png");

  const nameColor = getReceiverNameColor(type_id, template?.id);
  const userName = modalData?.name || modalData?.full_name || "";

  return (
    <StyledModal
      id="template-preview-modal"
      show={show}
      onHide={onClose}
      centered
      width="568px"
    >
      <TemplatePreviewModal>
        {/* Header */}
        <TemplatePreviewHeader>
          <div className="header-left">
            <div className="header-avatar">
              {!containsDefaultPng(loggedInUser?.profile_image) ? (
                <img
                  src={`${ImageUrl}/${loggedInUser?.profile_image}`}
                  alt="user"
                />
              ) : (
                <UserInitialsMain
                  isWidth={"48px"}
                  isHeight={"48px"}
                  isRadius={"40px"}
                  size={"16px"}
                  border
                  isBg
                  color={"#184A61"}
                >
                  {`${getInitials(loggedInUser?.fname)}${getInitials(loggedInUser?.lname)}`}
                </UserInitialsMain>
              )}
            </div>
            <div className="header-info">
              <div className="header-name">
                {`${loggedInUser?.fname || ""} ${loggedInUser?.lname || ""}`}
              </div>
              <div className="header-meta">
                {loggedInUser?.department && <span>{loggedInUser.department}</span>}
                {loggedInUser?.department && loggedInUser?.city && <span> | </span>}
                {loggedInUser?.city && <span>{loggedInUser.city}</span>}
                {/* {loggedInUser?.city && <span> | </span>} */}
                {/* <span>12:00am</span> */}
              </div>
            </div>
          </div>
          <ManagerIconContainer
            isWidth={"32px"}
            isHeight={"32px"}
            onClick={onClose}
            style={{ cursor: "pointer" }}
          >
            {ManagerCloseIcon()}
          </ManagerIconContainer>
        </TemplatePreviewHeader>

        <Divider isWidth={"94%"} id="modal-divider" isMargin={"16px 16px"}></Divider>

        <div className="TemplateCaption">Caption</div>

        {/* Template Image Area */}
        <TemplatePreviewImageBox>
          {/* Template background image */}
          <img
            className="template-bg"
            src={`${ImageUrl}/${template?.image_url}`}
            alt="template"
          />

          {/* User image + name overlay */}
          <div className="template-user-block">
            <div className="template-user-avatar">
              {!containsDefaultPng(modalData?.profile_image) ? (
                <img
                  src={`${ImageUrl}/${modalData?.profile_image}`}
                  alt={userName}
                />
              ) : (
                <UserInitialsMain
                  isWidth={"240px"}
                  isHeight={"240px"}
                  isRadius={"50%"}
                  size={"48px"}
                  border
                  isBg
                  color={"#184A61"}
                >
                  {getInitials(userName)}
                </UserInitialsMain>
              )}
            </div>
            <div
              className="template-user-name"
              style={{ color: nameColor }}
            >
              {userName}
            </div>
          </div>
        </TemplatePreviewImageBox>

        {/* Footer */}
        <TemplatePreviewFooter>
          <div className="footer-likes">
            Liked by <span className="highlight">Sonali Kailashiya</span> and{" "}
            <span className="highlight">25 others</span>
            <span style={{ marginLeft: "auto" }}> <span className="highlight">25</span> Comments</span>
          </div>
          <div className="footer-divider" />
          <div className="footer-actions">
            <div className="action-btn">
              {LikeIcon()}
              Like
            </div>
            <div className="action-btn">
              {SocialFeedCommentIcon()}
              Comment
            </div>
          </div>
        </TemplatePreviewFooter>
      </TemplatePreviewModal>
    </StyledModal>
  );
};

TemplatePreviewPopup.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  template: PropTypes.object,
  modalData: PropTypes.object,
  loggedInUser: PropTypes.object,
  type_id: PropTypes.number,
};

export default TemplatePreviewPopup;